import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SiteSummaryComponent } from './site-summary';
import { SiteDetailComponent } from './site-detail';
import { SiteCreateComponent } from './site-create';
import { SiteEditComponent } from './site-edit';
import { SiteRecordSheetComponent } from './site-record-sheet/site-record-sheet.component';
import { SiteEquipmentLayoutPlanComponent } from './site-equipment-layout-plan/site-equipment-layout-plan.component';
import { Authguard } from '../../../helper';
import { Roles } from '../../../model';

const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'Site'
    },
    children: [
      {
        path: 'summary',
        component: SiteSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'detail/:id',
        component: SiteDetailComponent,
        data: { title: 'Details' }
      },
      {
        path: 'edit/:id',
        component: SiteEditComponent,        
        canActivate: [ Authguard ],
        data: {
          title: 'Edit' ,
          permission: {
            role: [Roles.Admin, Roles.Engineer],
            redirectTo: '403'
          }
        }
      },
      {
        path: 'add',
        component: SiteCreateComponent,
        data: {
          title: 'Add' ,          
        }
      },
      {
        path: 'add/:id',
        component: SiteCreateComponent,
        data: {
          title: 'Add' ,          
        }
      },
      {
        path: 'recordSheet/:id',
        component: SiteRecordSheetComponent,
        data: { title: 'Add Record Sheet' }
      },
      {
        path: 'equipmentLayoutPlan/:siteId',
        children: [{
          path: ':itemId',
          component: SiteEquipmentLayoutPlanComponent,
          data: { title: 'Edit Equipment Layout Plan' }
        }, {
          path: '',
          component: SiteEquipmentLayoutPlanComponent,
          data: { title: 'Add Equipment Layout Plan' }
        }],
      },
      
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SiteRoutingModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-routing.module.ts